document.addEventListener("DOMContentLoaded", function () {

  /* ======================================================
     SAFE PRODUCT IMAGE CAROUSEL
     ====================================================== */

  const mainImages = document.querySelectorAll(".shop-main-image");
  const thumbnails = document.querySelectorAll(".shop-thumbnail");
  const prevArrow = document.querySelector(".shop-prev-arrow");
  const nextArrow = document.querySelector(".shop-next-arrow");
  const thumbnailContainer = document.getElementById("thumbnail-container");
  const indicatorsContainer = document.getElementById("thumbnail-indicators");

  if (!mainImages.length || !thumbnails.length) return;

  let currentIndex = 0;
  const totalImages = mainImages.length;

  function changeImage(index) {
    if (index < 0 || index >= totalImages) return;

    mainImages.forEach(img => {
      img.classList.remove("active");
      img.style.display = "none";
    });

    thumbnails.forEach(thumb => {
      thumb.classList.remove("active");
    });

    currentIndex = index;

    mainImages[currentIndex].classList.add("active");
    mainImages[currentIndex].style.display = "block";

    if (thumbnails[currentIndex]) {
      thumbnails[currentIndex].classList.add("active");
    }

    updateIndicators();
  }

  /* Thumbnail Click */
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", function () {
      changeImage(index);
    });
  });

  /* Arrow Navigation */
  if (prevArrow) {
    prevArrow.addEventListener("click", function () {
      changeImage((currentIndex - 1 + totalImages) % totalImages);
    });
  }

  if (nextArrow) {
    nextArrow.addEventListener("click", function () {
      changeImage((currentIndex + 1) % totalImages);
    });
  }

  /* Indicators */
  function updateIndicators() {
    if (!indicatorsContainer) return;

    indicatorsContainer.innerHTML = "";

    for (let i = 0; i < totalImages; i++) {
      const dot = document.createElement("div");
      dot.className = "indicator-dot";
      if (i === currentIndex) dot.classList.add("active");

      dot.addEventListener("click", function () {
        changeImage(i);
      });

      indicatorsContainer.appendChild(dot);
    }
  }

  updateIndicators();

  /* ======================================================
     SWIPE SUPPORT
     ====================================================== */

  const imageWrapper = document.querySelector(".shop-main-image-wrapper");

  if (imageWrapper) {
    let startX = 0;

    imageWrapper.addEventListener("touchstart", function (e) {
      startX = e.changedTouches[0].screenX;
    }, { passive: true });

    imageWrapper.addEventListener("touchend", function (e) {
      const endX = e.changedTouches[0].screenX;
      const delta = endX - startX;

      if (Math.abs(delta) > 30) {
        if (delta < 0) {
          changeImage((currentIndex + 1) % totalImages);
        } else {
          changeImage((currentIndex - 1 + totalImages) % totalImages);
        }
      }
    }, { passive: true });
  }

  /* ======================================================
     FAQ ACCORDION (SAFE)
     ====================================================== */

  const faqContainers = document.querySelectorAll("[data-faq-container]");

  faqContainers.forEach(container => {
    const faqItems = container.querySelectorAll("[data-faq-item]");
    if (!faqItems.length) return;

    faqItems.forEach(item => {
      const question = item.querySelector(".faq-question");
      if (!question) return;

      question.addEventListener("click", function () {
        item.classList.toggle("active");
      });
    });
  });

});
